/** Banca ore · periodicità di compensazione (1/3/4/6/12 mesi) e mese di inizio del periodo. */
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MONTHS_IT, COMPENSATION_PERIODS } from "@/lib/constants";

export function CompensationPeriodFields({ form, setForm, disabled }) {
  const monthly = Number(form.compensation_period_months) === 1;
  return (
    <>
      <div>
        <Label>Periodo compensazione</Label>
        <Select value={String(form.compensation_period_months)} disabled={disabled}
          onValueChange={(v) => setForm((f) => ({ ...f, compensation_period_months: Number(v) }))}>
          <SelectTrigger data-testid="company-form-compensation-period"><SelectValue /></SelectTrigger>
          <SelectContent>
            {COMPENSATION_PERIODS.map((p) => (
              <SelectItem key={p.months} value={String(p.months)} data-testid={`company-form-compensation-period-${p.months}`}>
                {p.label} ({p.months} {p.months === 1 ? "mese" : "mesi"})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Mese inizio periodo di compensazione</Label>
        <Select value={String(form.semester_start_month)} disabled={disabled || monthly}
          onValueChange={(v) => setForm((f) => ({ ...f, semester_start_month: Number(v) }))}>
          <SelectTrigger data-testid="company-form-semester-start"><SelectValue /></SelectTrigger>
          <SelectContent>{MONTHS_IT.map((m, i) => <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>)}</SelectContent>
        </Select>
        {monthly && <div className="mt-1 text-[11px] text-suite-neutral-500" data-testid="company-form-semester-start-monthly-hint">Con la compensazione mensile ogni mese di calendario è un periodo: il mese di inizio non incide.</div>}
      </div>
    </>
  );
}

export default CompensationPeriodFields;
